import { Injectable } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '../../common/models/common.model';
import { Supplier } from '../purchased-order.model';
import { buildHttpParams } from '../../utils';

@Injectable({
  providedIn: 'root',
})
export class SupplierService {
  private readonly baseUrl: string = 'suppliers/';

  constructor(private apiService: ApiService) {}

  public list(q = {}): Observable<PaginatedResponse<Supplier>> {
    const params = buildHttpParams(q);
    return this.apiService.get(this.baseUrl, params);
  }

  public light_list_suppliers(): Observable<{ id: string; name: string }[]> {
    return this.apiService.get(`${this.baseUrl}light_list_suppliers/`);
  }

  public patch(id: string, reqBody: any): Observable<Supplier> {
    return this.apiService.patch(`${this.baseUrl}${id}/`, reqBody);
  }

  public post(reqBody: any): Observable<Supplier> {
    return this.apiService.post(this.baseUrl, reqBody);
  }

  public delete(id: string): Observable<void> {
    return this.apiService.delete(`${this.baseUrl}${id}/`);
  }
}
